module.exports = __webpack_public_path__ + "media/svg-new/layout-007564d0.svg";